import toastr from 'toastr';

export const STATUS_MAP = {
    DRAFT: 'DRAFT',
    REJECTED: 'REJECTED',
    APPROVED: 'APPROVED',
    PENDING_APPROVAL: 'PENDING_APPROVAL'
}

export const getStatusBadge = (status) => {
    switch (status) {
        case STATUS_MAP.DRAFT:
            return 'badge badge-secondary';
        case STATUS_MAP.REJECTED:
            return 'badge badge-danger';
        case STATUS_MAP.APPROVED:
            return 'badge badge-success';
        case STATUS_MAP.PENDING_APPROVAL:
            return 'badge badge-warning';
        default:
            return 'badge badge-light';
    }
}

export const statusName = (status) => {
    if (status === STATUS_MAP.PENDING_APPROVAL) {
        return status.replace('_', ' ');
    } else {
        return status;
    }
}

export const submitCreative = async function (creative) {
    this.form.creative_id = creative.creativeId;

    if (!this.form.platform_id) {
        this.errors.platform = 'Please select platform';
    }

    if (!this.form.company_id && this.isMasterAdmin) {
        this.errors.company = 'Please select company';
    }

    if (Object.keys(this.errors).length > 0) {
        toastr.error('Please check errors');
        return false;
    }

    try {
        const { data } = await axios.post('/admin/auth/walmart/submit-creative', this.form);

        if (data?.result?.original?.status === 'error') {
            toastr.error(data.result.original.message);
            return false;
        }

        if (data?.status === 'error' || data?.status === 'failed') {
            toastr.error(data.message);
            return false;
        }

        toastr.success('Creative submitted successfully');
        return true;
    } catch (error) {
        toastr.error('An unexpected error occurred. Please try again.');
        return false;
    }
}

export const downloadCreativeMetadata = async function (id) {
    try {
        this.form.creative_id = id;

        const response = await axios({
            url: '/admin/auth/walmart/download-creative-metadata',
            method: 'POST',
            data: this.form,
            responseType: 'blob'
        });

        const blob = new Blob([response.data], { type: 'application/json' });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `creative_${id}_metadata.json`);
        document.body.appendChild(link);
        link.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);

        toastr.success('Creative metadata downloaded successfully');
    } catch (error) {
        console.error('Error downloading metadata:', error);
        toastr.error('Failed to download creative metadata');
    }
}
